'use client';

import { generateDataLayerContact } from '@/src/utils/seo/analytics';

interface IProps {
  email?: string | null;
  subject?: string | null;
  text?: string | null;
}

export const EmailButton = ({ email, subject, text }: IProps) => {
  return (
    <a
      className={
        'cursor-pointer rounded-3xl bg-primary px-6 py-3 text-white no-underline active:bg-primary-dark'
      }
      onClick={() => {
        window.dataLayer?.push(generateDataLayerContact());
      }}
      href={`mailto:${email}?subject=${encodeURIComponent(subject || '')}`}
    >
      {text}
    </a>
  );
};
